import { type Page, typedApi } from "@/api/typed-client";
import { useQuery } from "@tanstack/react-query";

export type { Page };

export interface Project {
  id: string;
  name: string;
  description: string | null;
  created_at: string;
  updated_at: string;
}

export function useProjects() {
  return useQuery({
    queryKey: ["projects"],
    queryFn: async () => {
      const { data, error } = await typedApi.GET("/v1/projects", {
        // Justified: list projects has no query params in OpenAPI schema; backend does accept page_size
        params: { query: { page_size: 100 } as never },
      });
      if (error) throw new Error(JSON.stringify(error));
      // Justified: Page_ProjectOut_ is structurally compatible but openapi-fetch widens the type
      return data as unknown as Page<Project>;
    },
  });
}
